import {
    REQUEST_DOC_CATEGORIES,
    RECEIVE_DOC_CATEGORIES,
    UPDATE_DOC_CATEGORIES,
    ERROR_DOC_CATEGORIES
} from '../types'
import {fetchUrl} from '../../constants/constants'
import {requestItem, receiveItem, failedItem} from "../actions"
import fetchErrorCtrl from "../../helpers/fetchErrorCtrl"
import shouldFetch from "../../helpers/shouldFetch"
import {reloadEnums, getEnums} from "../actions"
import axios from 'axios'
import prepareFilters from "../../helpers/prepareFilters";

function request() {
    return {
        type: REQUEST_DOC_CATEGORIES
    };
}

export function receive(data) {
    return {
        type: RECEIVE_DOC_CATEGORIES,
        payload: data
    }
}

function failed(data) {
    return {
        type: ERROR_DOC_CATEGORIES,
        errors: data
    }
}

function update(data, id, updateType) {
    return {
        type: UPDATE_DOC_CATEGORIES,
        id,
        payload: data,
        updateType
    }
}

export function getDocCategories(params = {}, force = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().docCategories, !force)) {
            dispatch(request())
            return axios({
                method: 'GET',
                url: fetchUrl + 'doc-categories',
                params: prepareFilters(params, getState(), "docCategories")
            }).then(res => {
                dispatch(receive(res.data.data))
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failed(errors))
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function getDocCategory(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('docCategory'))
            return axios({
                method: 'GET',
                url: fetchUrl + 'doc-categories/' + id
            }).then(res => {
                dispatch(receiveItem(res.data.data))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function createDocCategory(data, fromSelect = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            if(!fromSelect){
                dispatch(requestItem())
            }
            return axios({
                method: 'POST',
                url: fetchUrl + 'doc-categories',
                data
            }).then(res => {
                if(fromSelect){
                    dispatch(getEnums('docCategories', {}, true));
                    return res.data.data.id
                }else{
                    dispatch(receiveItem({}, 'message.item_created'))
                    dispatch(update(res.data.data, false, 'create'))
                    dispatch(reloadEnums('docCategories'))
                }
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function updateDocCategory(data, id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('docCategory'))
            return axios({
                method: 'PUT',
                url: fetchUrl + 'doc-categories/' + id,
                data
            }).then(res => {
                dispatch(receiveItem(res.data.data, 'message.item_updated'))
                dispatch(update(res.data.data, id, 'update'))
                dispatch(reloadEnums('docCategories'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function deleteDocCategory(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'DELETE',
                url: fetchUrl + 'doc-categories/' + id
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_deleted'))
                dispatch(update(res.data.data, id, 'delete'))
                dispatch(reloadEnums('docCategory'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}